import React from "react";

const QuestionBank = () => {
  return <div>QuestionBank</div>;
};

export default QuestionBank;
